import React, { forwardRef, Ref } from 'react';
import { IconBaseProps, SizeTypes } from '../interface';
import classNames from 'classnames';
import { usePrefixCls } from '../../_utils';

const SuccessIcon = forwardRef((props: IconBaseProps, ref: Ref<SVGSVGElement>) => {
  const prefixCls = usePrefixCls('icon');
  const { size, color, className, style: customStyle, ...restProps } = props;

  let isFontSize = false;
  let isSize = false;
  if (typeof size === 'number') {
    isFontSize = true;
  } else {
    isSize = SizeTypes.findIndex(item => item === size) !== -1;
  }

  const classes = classNames(
    prefixCls,
    prefixCls + '--success',
    { ['size-' + size]: isSize },
    className,
  );

  const style = {
    color,
    fontSize: isFontSize ? size : undefined,
    ...customStyle,
  };

  return (
    <svg
      ref={ref}
      className={classes}
      style={style}
      {...restProps}
      height="16px"
      width="16px"
      version="1.1"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>success</title>
      <g id="success" fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g>
          <rect height="16" width="16" x="0" y="0" />
          <rect
            height="2"
            width="5"
            fill="currentColor"
            fillRule="nonzero"
            transform="translate(6.474874, 8.889087) rotate(45.000000) translate(-6.474874, -8.889087)"
            x="3.9748736"
            y="7.88908702"
          />
          <rect
            height="7"
            width="2"
            fill="currentColor"
            fillRule="nonzero"
            transform="translate(9.303301, 8.181981) rotate(45.000000) translate(-9.303301, -8.181981)"
            x="8.30330124"
            y="4.68198056"
          />
          <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="2" />
        </g>
      </g>
    </svg>
  );
});

export default SuccessIcon;
